export default "__VITE_ASSET__BhvRBeWp__"